export const aproposTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'À propos',
  hero_h1: 'À propos de Couvreur-Lévis.com',
  hero_subtitle: "Un service 100% lévien qui met en relation propriétaires et couvreurs qualifiés de la région.",
  hero_cta: "Demander une soumission",

  // Notre histoire
  histoire_h2: "Notre histoire en quelques mots",
  histoire_p1: "Couvreur-Lévis.com est né du constat que trouver un couvreur fiable à Lévis était devenu un parcours du combattant. Nous avons créé cette plateforme pour simplifier la mise en relation entre propriétaires et couvreurs qualifiés de la région.",
  histoire_p2: "Avant Couvreur-Lévis.com, les propriétaires devaient appeler couvreur par couvreur, comparer des soumissions sur des formats différents, et espérer ne pas tomber sur un entrepreneur sans licence. Nous avons changé ça en créant un réseau vérifié : chaque couvreur partenaire est certifié CCQ, assuré et référencé avec soin.",
  histoire_p3: "Aujourd'hui, notre plateforme met en relation plus de 10 couvreurs partenaires qualifiés à Lévis, Saint-Romuald, Saint-Nicolas, Charny et secteurs environnants. Plus de 200 propriétaires ont déjà trouvé leur couvreur via Couvreur-Lévis.com. On grandit grâce au bouche-à-oreille. Et on compte bien continuer comme ça.",

  // Valeurs
  valeurs_h2: "Ce qui nous différencie",
  valeur_1_title: 'TRANSPARENCE DES PRIX',
  valeur_1_desc: "Soumissions détaillées ligne par ligne. Pas de petits caractères. Pas de surprise. Vous comparez en toute clarté.",
  valeur_2_title: 'SÉLECTION RIGOUREUSE',
  valeur_2_desc: "Chaque couvreur partenaire est vérifié : licence RBQ valide, assurance RC, expérience confirmée et références vérifiées.",
  valeur_3_title: "100% LOCAL À LÉVIS",
  valeur_3_desc: "Tous nos couvreurs partenaires sont basés à Lévis et connaissent les spécificités climatiques et architecturales de la région.",
  valeur_4_title: 'CONFIANCE CERTIFIÉE',
  valeur_4_desc: "Nous ne référons QUE des couvreurs certifiés RBQ. Pas de sous-traitants inconnus. Pas de licences douteuses.",

  // Comment ça marche (anciennement Équipe)
  equipe_h2: "Comment fonctionne Couvreur-Lévis.com",
  equipe_subtitle: "4 étapes simples pour trouver le bon couvreur à Lévis",
  step_1_title: "Vous décrivez votre projet",
  step_1_desc: "Remplissez notre formulaire en 2 minutes : type de travail, matériau, superficie approximative et vos coordonnées.",
  step_2_title: "Nous sélectionnons les bons partenaires",
  step_2_desc: "Notre algorithme sélectionne 1 à 3 couvreurs partenaires qualifiés près de chez vous, selon leur spécialité et disponibilité.",
  step_3_title: "Contact rapide sous 2h",
  step_3_desc: "Les couvreurs partenaires sélectionnés vous contactent sous 2h ouvrables pour une soumission gratuite et sans engagement.",
  step_4_title: "Vous choisissez librement",
  step_4_desc: "Comparez les soumissions, discutez avec les couvreurs et choisissez celui qui vous convient le mieux. Aucune obligation.",

  // Certifications
  certifications_h2: "Nos critères de sélection des partenaires",
  cert_1: "Licence RBQ valide — vérifiée pour chaque partenaire",
  cert_2: "Maître Couvreur certifié",
  cert_3: 'CCQ - Commission construction Québec',
  cert_4: "Assurance RC 2M$ minimum",
  cert_5: 'Membre AMCQ',
  cert_6: 'CNESST en règle',

  // Zones
  zones_h2: "Où nos partenaires interviennent",
  zones_intro: "Nos couvreurs partenaires se déplacent dans tout Lévis et les secteurs environnants. Voici la zone que nous couvrons :",
  zone_1: 'Lévis centre',
  zone_2: 'Saint-Romuald',
  zone_3: 'Saint-Nicolas',
  zone_4: 'Charny',
  zone_5: 'Pintendre',
  zone_6: 'Saint-Jean-Chrysostome',
  zone_7: 'Lauzon',
  zone_8: "Saint-Étienne-de-Lauzon",
  zone_9: 'Beaumont',
  zone_10: 'Saint-Lambert',

  // Chiffres
  chiffres_h2: "Couvreur-Lévis.com en chiffres",
  chiffre_1_num: '10+',
  chiffre_1_label: "couvreurs partenaires à Lévis",
  chiffre_2_num: '200+',
  chiffre_2_label: "mises en relation réussies",
  chiffre_3_num: '10-25',
  chiffre_3_label: "ans d'expérience des partenaires",

  // Garantie
  garantie_h2: "Tous nos couvreurs partenaires offrent une garantie écrite 10 ans",
  garantie_text: "Chaque chantier réalisé par nos couvreurs partenaires vient avec garantie écrite 10 ans sur main-d'œuvre. En cas d'infiltration due à un défaut de pose, le couvreur revient réparer sans frais. C'est l'engagement de qualité que nous exigeons de chaque partenaire.",

  // Témoignage
  temoignage_h2: "Témoignage",
  temoignage_quote: "On a utilisé Couvreur-Lévis.com en 2019 pour trouver un couvreur pour la réfection complète de notre toit en bardeau à Saint-Nicolas. En moins de 2 heures, on avait reçu 3 soumissions détaillées. Le couvreur qu'on a choisi a fait l'inspection, a pris des photos, nous a expliqué chaque étape avec patience. Le chantier a duré 4 jours, l'équipe était toujours ponctuelle et le soir ils ramassaient tout. Quatre ans plus tard, zéro problème. En 2023, quand notre garage a eu besoin d'une toiture en tôle, on est repassés par Couvreur-Lévis.com. On a aussi recommandé à notre belle-sœur et à notre voisin. Quand un service fait ça bien, ça se partage tout seul.",
  temoignage_author: "François et Hélène B.",
  temoignage_city: 'Saint-Nicolas',
  temoignage_detail: "Clients depuis 2019",
  temoignage_disclaimer: "Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.",

  // CTA Final
  cta_h2: "Trouvez votre couvreur aujourd'hui",
  cta_subtitle: 'Soumission gratuite en 2h, couvreurs partenaires certifiés, garantie 10 ans.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: "418-476-9950",
};

export default aproposTranslations;